/*
 * linkParams
 */

/*
 * HOW TO - dynamic query params for enquiry links
 *
 * Use this module to append query parameters to links via data attributes.
 * Parameters are defined in Twig as an object and passed as JSON through
 * the `data-query-params` attribute. Dont forget to set the class `js-linkParams`.
 * 
 * IMPORTANT:
 * - Always use `json_encode|e`
 * - Do NOT use `raw`
 * - Do NOT use `e('html_attr')`
 *
 * Reason:
 * - `json_encode` creates valid JSON
 * - `e` makes the JSON safe for HTML attributes
 * - the browser decodes it back to valid JSON
 * - `JSON.parse()` can safely consume it in JS
 *
 * Placeholders like `[$RoomCategory.Id$]` are resolved by the CMS
 * AFTER Twig rendering and BEFORE JavaScript execution.
 * JavaScript only ever works with final values (e.g. numbers).
 *
 * Example usage in Twig:
 * 
 * {% set queryParams = {
 *  'wl-quick-roomcategory-id': '[$RoomCategory.Id$]'
 *  'presetPackageId': '[$Package.Id$]'
 * } %}
 * 
 * {% include '_elements/link/link.twig' with {
 *  props: props._globals._enquiry|deepMerge(props._enquiryButton, true)|deepMerge({
 *  classes: ['js-linkParams'],
 *  attr: {
 *    'data-query-params': queryParams|json_encode|e,
 *  }
 * }, true)
 * 
 */

const linkParams = {
  cfg: {
    name: 'linkParams',
    selectors: {
      link: 'a.js-linkParams',
    },
    el: {
      $linkParams: [],
    },
  },

  setElements() {
    this.cfg.el.$linkParams = [...document.querySelectorAll(this.cfg.selectors.link)];
  },

  applyParams(link) {
    const url = new URL(link.href, window.location.origin);

    const raw = link.getAttribute('data-query-params');
    if (!raw) return;

    let paramsObj;
    try {
      paramsObj = JSON.parse(raw);
    } catch (err) {
      console.warn('[linkParams] Invalid JSON in data-query-params', err, link);
      return;
    }

    Object.entries(paramsObj).forEach(([param, value]) => {
      if (value == null || value === '') return;
      if (!url.searchParams.has(param)) {
        url.searchParams.set(param, String(value));
      }
    });

    link.href = url.toString();
  },
  
  applyParamsToLinks() {
    this.cfg.el.$linkParams.forEach((link) => {
      this.applyParams(link);
    });
  },

  init() {
    console.debug(`Init: ${this.cfg.name}`);
    this.setElements();

    if (this.cfg.el.$linkParams.length) {
      this.applyParamsToLinks();
    }
  },
};

export default linkParams;
